module.exports = __webpack_public_path__ + "static/img/VipuvoimaaEU_2014_2020_rgb_white.708d313.png";